"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

var pattern_1 = require("../../../utils/pattern");

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var weeks_1 = require("../../../calculation/weeks");

var PATTERN = new RegExp("(?:(?:\\,|\\(|\\（)\\s*)?" + "(?:(este|esta|passado|pr[oó]ximo)\\s*)?" + "(".concat(pattern_1.matchAnyPattern(constants_1.WEEKDAY_DICTIONARY), ")") + "(?:\\s*(?:\\,|\\)|\\）))?" + "(?:\\s*(este|esta|passado|pr[óo]ximo)\\s*semana)?" + "(?=\\W|\\d|$)", "i");
var PREFIX_GROUP = 1;
var WEEKDAY_GROUP = 2;
var POSTFIX_GROUP = 3;

var PTWeekdayParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(PTWeekdayParser, _AbstractParserWithWo);

  var _super = _createSuper(PTWeekdayParser);

  function PTWeekdayParser() {
    _classCallCheck(this, PTWeekdayParser);

    return _super.apply(this, arguments);
  }

  _createClass(PTWeekdayParser, [{
    key: "innerPattern",
    value: function innerPattern() {
      return PATTERN;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var dayOfWeek = match[WEEKDAY_GROUP].toLowerCase();
      var offset = constants_1.WEEKDAY_DICTIONARY[dayOfWeek];

      if (offset === undefined) {
        return null;
      }

      var prefix = match[PREFIX_GROUP];
      var postfix = match[POSTFIX_GROUP];
      var norm = prefix || postfix || "";
      norm = norm.toLowerCase();
      var modifier = null;

      if (norm == "passado") {
        modifier = "this";
      } else if (norm == "próximo" || norm == "proximo") {
        modifier = "next";
      } else if (norm == "este") {
        modifier = "this";
      }

      var date = weeks_1.toDayJSWeekday(context.refDate, offset, modifier);
      return context.createParsingComponents().assign("weekday", offset).imply("day", date.date()).imply("month", date.month() + 1).imply("year", date.year());
    }
  }]);

  return PTWeekdayParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = PTWeekdayParser;